import calendarRepository from './calendarRepository';

export default class CalendarPresenter {
  async initCalendar(callback, id) {
    await calendarRepository.initCalendar((calendarPm) => {
      const generatedVm = {
        calendarData: JSON.parse(JSON.stringify(calendarPm.calendarData)),
        selectedWeek: calendarPm.selectedWeek,
        isLoading: calendarPm.isLoading,
      };

      callback(generatedVm);
    }, id);
  }

  async prevWeek() {
    await calendarRepository.getPrevWeekData();
  }
  async reset() {
    await calendarRepository.resetSelectedWeek();
  }

  async nextWeek() {
    await calendarRepository.getNextWeekData();
  }
}
